import functions from "./functions.js";
import {SimpleGuests, SimpleGuestsDefaults} from "./simple-guests.js";

$(function () {

    const $form = $('.form-contact');
    const form = $form[0];

    if (!form) {
        return;
    }

    $form.on('submit', e => {
        e.preventDefault();

        $('.contact-btn').addClass('d-none');
        $('.contact-spinner').removeClass('d-none');
        $('.contact-spinner').addClass('d-flex');

        let params = {};
        $.each($form.serializeArray(), function (i, field) {
            params[field.name] = field.value;
        });

        params['language'] = functions.getLang();

        grecaptcha.ready(function () {
            grecaptcha.execute('6Lclfu0gAAAAANUqIZ53gAHM2YS0sWiwuATfWq2i', { action: 'contact' }).then(function (token) {
                params['gRecaptchaToken'] = token;
                params = functions.getDataForUrl(params);
                $.post('/services/contact/', params).then(response => {

                    $('#contact-modal').modal('show');
                    $(".response-output").html(response.data);

                    $('.contact-btn').removeClass('d-none');
                    $('.contact-spinner').removeClass('d-flex');
                    $('.contact-spinner').addClass('d-none');

                    setTimeout(() => {
                        $('#contact-modal').modal('hide');
                        // details contact modal
                        $('#contactModal').modal('hide');
                    }, 4000);

                    if (response.status == true) {
                        form.reset();
                    }
                });
            });
        });

    });

});